import { render, staticRenderFns } from "./3-1.vue?vue&type=template&id=6b1c198a&scoped=true&"
import script from "./3-1.vue?vue&type=script&lang=js&"
export * from "./3-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c198a",
  null
  
)

export default component.exports